<template>
  <svg
    :class="[color, direction]"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="11"
    viewBox="0 0 18 11"
  >
    <path
      class="fatchevron"
      id="Path_2379"
      data-name="Path 2379"
      d="M602.426,481.611l-9-8.913,2.107-2.087,6.893,6.826,6.893-6.826,2.107,2.087Z"
      transform="translate(-593.426 -470.611)"
      fill="#2d323c"
    />
  </svg>
</template>

<script>
export default {
  props: ['color', 'direction'],
  name: 'ChevronFat',
}
</script>

<style lang="scss" scoped>
.a {
  transition: all ease 0.3s;
  fill: #2d323c;
  transition: all ease 0.3s;
}
svg {
  transition: all ease 0.3s;
}
.left {
  transform: rotate(90deg);
}
.right {
  transform: rotate(-90deg);
}
.up {
  transform: rotate(-180deg);
}
.down {
  transform: rotate(0);
}

.ocean {
  path {
    fill: #05b5bc;
  }
}
.twilight {
  path {
    fill: $twilight;
  }
}
.white {
  path {
    fill: white;
  }
}
.sleet {
  &:hover {
    .a {
      fill: $strom;
    }
  }
  .a {
    fill: #d2d7dc;
  }
}
</style>
